module.exports = __webpack_public_path__ + "static/video-thumb-e941c0c2ead7ec2e042467a639977af0.png";